/* Block Dwell's cart dialog from opening via showModal — their dialog.js
   sets body to position:fixed and opens a top-layer dialog that ignores
   display:none CSS, freezing the page. This only blocks cart-drawer-component.
   We also undo the body styles that showDialog() sets BEFORE calling showModal(),
   since closeDialog() won't clean them up when the dialog never actually opened. */
(function() {
  var orig = HTMLDialogElement.prototype.showModal;
  HTMLDialogElement.prototype.showModal = function() {
    if (this.closest('cart-drawer-component')) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      return;
    }
    return orig.apply(this, arguments);
  };
})();

/**
 * Mosterd Cart Drawer
 * -------------------
 * Slide-out cart from the right.
 * Opens on Dwell's "cart:update" event (add-to-cart), data-cart-drawer-open click,
 * and intercepts [href="/cart"] links.
 * Quantity changes and removals via Shopify AJAX Cart API.
 */
(function () {
  'use strict';

  /* ---- DOM refs ---- */
  const overlay   = document.querySelector('[data-cart-overlay]');
  const drawer    = document.querySelector('[data-cart-drawer]');
  if (!overlay || !drawer) return;

  const closeBtn  = drawer.querySelector('[data-cart-drawer-close]');
  const threshold = Number(drawer.dataset.freeShippingThreshold) || 699;

  /* ---- Open / Close helpers ---- */
  function open() {
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawer.removeAttribute('aria-hidden');
  }

  function close() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    drawer.setAttribute('aria-hidden', 'true');
    // Move focus out of drawer before hiding to avoid aria warning
    document.body.focus();
  }

  /* ---- Close triggers ---- */
  overlay.addEventListener('click', close);
  if (closeBtn) closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      close();
    }
  });

  /* ---- Open on Dwell cart:update (add-to-cart) ---- */
  document.addEventListener('cart:update', function (e) {
    refreshDrawer().then(open);
  });

  /* ---- Open on [data-cart-drawer-open] click ---- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cart-drawer-open]');
    if (trigger) {
      e.preventDefault();
      refreshDrawer().then(open);
    }
  });

  /* ---- Intercept [href="/cart"] links ---- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href="/cart"], a[href="/cart/"]');
    if (link && !e.ctrlKey && !e.metaKey) {
      e.preventDefault();
      refreshDrawer().then(open);
    }
  });

  /* ---- Intercept Dwell's cart-drawer-component trigger button ---- */
  document.addEventListener('click', function (e) {
    /* Skip clicks inside the Mosterd drawer itself (checkout, product links, etc.) */
    if (e.target.closest('[data-cart-drawer]')) return;

    var trigger = e.target.closest('cart-drawer-component button, cart-drawer-component [on\\:click]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      refreshDrawer().then(open);
    }
  }, true);

  /* ---- Checkout button — ensure navigation always works ---- */
  drawer.addEventListener('click', function (e) {
    var checkoutLink = e.target.closest('.md-cd-checkout-btn');
    if (checkoutLink && checkoutLink.href) {
      e.stopPropagation();
      close();
      window.location.href = checkoutLink.href;
    }
  });

  /* ---- Quantity buttons (delegated) ---- */
  drawer.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus  = e.target.closest('[data-qty-plus]');
    var remove = e.target.closest('[data-remove-item]');

    if (minus) {
      var line = Number(minus.dataset.line);
      var valEl = minus.closest('.md-cd-item').querySelector('[data-qty-val]');
      var qty = Math.max(0, Number(valEl.textContent) - 1);
      updateLine(line, qty);
    } else if (plus) {
      var line = Number(plus.dataset.line);
      var valEl = plus.closest('.md-cd-item').querySelector('[data-qty-val]');
      var qty = Number(valEl.textContent) + 1;
      updateLine(line, qty);
    } else if (remove) {
      var line = Number(remove.dataset.line);
      updateLine(line, 0);
    }
  });

  /* ---- Upsell scroll nav ---- */
  drawer.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-upsell-prev]');
    var next = e.target.closest('[data-upsell-next]');
    if (!prev && !next) return;
    var list = drawer.querySelector('[data-upsell-scroll]');
    if (!list) return;
    var amount = 220;
    list.scrollBy({ left: prev ? -amount : amount, behavior: 'smooth' });
  });

  /* ---- Gift wrap toggle (delegated) ---- */
  drawer.addEventListener('change', function (e) {
    var toggle = e.target.closest('[data-giftwrap-toggle]');
    if (!toggle) return;
    var wrap = toggle.closest('[data-giftwrap]');
    var variantId = wrap.dataset.variantId;
    var checked = toggle.checked;
    var dateField = wrap.querySelector('[data-giftwrap-date-wrap]');

    if (checked) {
      if (dateField) dateField.style.display = 'block';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) { renderCart(cart); updateCartIcon(cart.item_count); })
        .catch(function (err) { console.error('[cart-drawer] gift wrap add error', err); toggle.checked = false; });
    } else {
      if (dateField) dateField.style.display = 'none';
      // Remove gift wrap by setting quantity to 0 via variant id
      var updates = {};
      updates[variantId] = 0;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); updateCartIcon(cart.item_count); })
        .catch(function (err) { console.error('[cart-drawer] gift wrap remove error', err); toggle.checked = true; });
    }
  });

  /* ---- Gift wrap date → cart attribute ---- */
  drawer.addEventListener('input', function (e) {
    var dateInput = e.target.closest('[data-giftwrap-date]');
    if (!dateInput) return;
    clearTimeout(dateInput._debounce);
    dateInput._debounce = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Gave-dato': dateInput.value } })
      }).catch(function (err) { console.error('[cart-drawer] gift date error', err); });
    }, 500);
  });

  /* ---- Upsell add-to-cart (delegated) ---- */
  var _upsellBusy = false;
  drawer.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-upsell-add]');
    if (!addBtn || addBtn.disabled || _upsellBusy) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    _upsellBusy = true;
    var variantId = addBtn.dataset.variantId;
    addBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        addBtn.classList.add('md-cd-upsell-item__add--added');
        addBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M5 12L10 17L19 7"/></svg>';
        setTimeout(function () {
          addBtn.disabled = false;
          _upsellBusy = false;
          addBtn.classList.remove('md-cd-upsell-item__add--added');
          addBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M12 5V19M5 12H19"/></svg>';
        }, 1500);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        renderCart(cart);
        updateCartIcon(cart.item_count);
      })
      .catch(function (err) {
        console.error('[cart-drawer] upsell add error', err);
        addBtn.disabled = false;
        _upsellBusy = false;
        addBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M12 5V19M5 12H19"/></svg>';
      });
  });

  /* ---- AJAX cart change ---- */
  function updateLine(line, quantity) {
    // Get the variant id from the DOM element to use as fallback
    var itemEl = drawer.querySelector('[data-cart-item][data-line="' + line + '"]');
    var variantId = itemEl ? itemEl.dataset.variantId : null;

    // Prefer variant id (more reliable than line index after re-renders)
    var endpoint, body;
    if (variantId) {
      var updates = {};
      updates[variantId] = quantity;
      body = JSON.stringify({ updates: updates });
      endpoint = '/cart/update.js';
    } else {
      body = JSON.stringify({ line: line, quantity: quantity });
      endpoint = '/cart/change.js';
    }

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        updateCartIcon(cart.item_count);
      })
      .catch(function (err) {
        console.error('[cart-drawer] update error', err);
      });
  }

  /* ---- Refresh drawer via /cart.js ---- */
  function refreshDrawer() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        updateCartIcon(cart.item_count);
      })
      .catch(function (err) {
        console.error('[cart-drawer] refresh error', err);
      });
  }

  /* ---- Re-render cart contents from JSON ---- */
  function renderCart(cart) {
    var body   = drawer.querySelector('[data-cart-items]');
    var count  = drawer.querySelector('[data-cart-count]');
    var subtot = drawer.querySelector('[data-cart-subtotal]');
    var total  = drawer.querySelector('[data-cart-total]');
    var shipMsg = drawer.querySelector('[data-shipping-msg]');
    var shipFill = drawer.querySelector('[data-shipping-fill]');

    // Update count badge
    if (count) count.textContent = '(' + cart.item_count + ')';

    // Shipping bar
    var cartTotalKr = cart.total_price / 100;
    var remaining = Math.max(0, threshold - cartTotalKr);
    var pct = cartTotalKr >= threshold ? 100 : Math.round((cartTotalKr / threshold) * 100);

    if (shipFill) shipFill.style.width = pct + '%';
    if (shipMsg) {
      if (cart.item_count === 0) {
        shipMsg.innerHTML = 'Fri fragt ved k\u00F8b over ' + threshold + ' kr';
      } else if (remaining > 0) {
        shipMsg.innerHTML = 'K\u00F8b for <strong>' + Math.round(remaining) + ' kr</strong> mere \u2014 f\u00E5 fri fragt!';
      } else {
        shipMsg.innerHTML = '\u2713 Du har fri fragt!';
      }
    }

    // Subtotals / total
    var formattedTotal = formatMoney(cart.total_price);
    if (subtot) subtot.textContent = formattedTotal;
    if (total)  total.textContent  = formattedTotal;

    // Items
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="md-cart-empty">' +
          '<div class="md-cart-empty__icon">&#128722;</div>' +
          '<p class="md-cart-empty__text">Din kurv er tom</p>' +
          '<a href="/collections/all" class="md-cart-empty__cta">Se produkter</a>' +
        '</div>';
      // Update footer
      var totalsEl = drawer.querySelector('[data-cart-totals]');
      if (totalsEl) totalsEl.style.display = 'none';
      var checkoutBtn = drawer.querySelector('[data-cart-checkout-btn]');
      if (checkoutBtn) {
        checkoutBtn.href = '/collections/all';
        checkoutBtn.textContent = 'Se produkter';
      }
      // Hide gift wrap
      var gwEl = drawer.querySelector('[data-giftwrap]');
      if (gwEl) gwEl.style.display = 'none';
      return;
    }

    // Rebuild items HTML
    var gwEl = drawer.querySelector('[data-giftwrap]');
    var gwVariantId = gwEl ? gwEl.dataset.variantId : '';
    var gwInCart = false;
    var html = '';
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var line = i + 1;
      if (gwVariantId && String(item.variant_id) === gwVariantId) {
        gwInCart = true;
      }
      var varTitle = item.variant_title || '';
      var imgSrc = item.image ? sizedImage(item.image, '128x') : '';
      var predate = item.properties && item.properties._predate ? true : false;

      html += '<div class="md-cd-item" data-cart-item data-line="' + line + '" data-variant-id="' + item.variant_id + '">';
      html += '<a href="' + item.url + '">';
      if (imgSrc) {
        html += '<img class="md-cd-item-img" src="' + imgSrc + '" alt="' + escapeHtml(item.product_title) + '" width="76" height="90" loading="lazy">';
      }
      html += '</a>';
      html += '<div class="md-cd-item__info">';
      if (item.vendor) {
        html += '<div class="md-cd-item-brand">' + escapeHtml(item.vendor) + '</div>';
      }
      html += '<a href="' + item.url + '" class="md-cd-item-name">' + escapeHtml(item.product_title) + '</a>';
      if (varTitle && varTitle !== 'Default Title') {
        html += '<div class="md-cd-item-variant">' + escapeHtml(varTitle) + '</div>';
      }
      if (predate) {
        html += '<span class="md-cd-item__preorder-badge">Forudbestilling</span>';
      }
      html += '<div class="md-cd-item-qty-row">';
      html += '<div class="md-cd-item-price">' + formatMoney(item.final_line_price) + '</div>';
      html += '<div class="md-cd-item-qty">';
      html += '<button class="md-cd-qty-btn" aria-label="Fjern en" data-qty-minus data-line="' + line + '">&minus;</button>';
      html += '<span class="md-cd-qty-val" data-qty-val>' + item.quantity + '</span>';
      html += '<button class="md-cd-qty-btn" aria-label="Tilf\u00F8j en" data-qty-plus data-line="' + line + '">&plus;</button>';
      html += '</div>';
      html += '<button class="md-cd-item-remove" aria-label="Fjern" data-remove-item data-line="' + line + '"><svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 4h12M5.333 4V2.667a1.333 1.333 0 011.334-1.334h2.666a1.333 1.333 0 011.334 1.334V4m2 0v9.333a1.333 1.333 0 01-1.334 1.334H4.667a1.333 1.333 0 01-1.334-1.334V4h9.334z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
      html += '</div>';
      html += '</div>';
      html += '</div>';
    }
    body.innerHTML = html;

    // Update gift wrap checkbox + date field + visibility
    if (gwEl) {
      // Count real items (non-giftwrap)
      var realItemCount = cart.items.length - (gwInCart ? 1 : 0);
      gwEl.style.display = realItemCount > 0 ? '' : 'none';
      var gwToggle = gwEl.querySelector('[data-giftwrap-toggle]');
      var gwDateWrap = gwEl.querySelector('[data-giftwrap-date-wrap]');
      if (gwToggle) gwToggle.checked = gwInCart;
      if (gwDateWrap) gwDateWrap.style.display = gwInCart ? 'block' : 'none';
    }

    // Ensure footer shows totals + checkout
    var totalsEl = drawer.querySelector('[data-cart-totals]');
    if (totalsEl) totalsEl.style.display = '';
    var shippingText = drawer.querySelector('[data-cart-shipping-text]');
    if (shippingText) {
      shippingText.textContent = cartTotalKr >= threshold ? 'Gratis' : 'Beregnes ved kassen';
    }
    var checkoutBtn = drawer.querySelector('[data-cart-checkout-btn]');
    if (checkoutBtn) {
      checkoutBtn.href = '/checkout';
      checkoutBtn.textContent = drawer.dataset.checkoutText || 'G\u00E5 til kassen \u2192';
    }
  }

  /* ---- Update Dwell header cart icon count ---- */
  function updateCartIcon(count) {
    // Let Dwell's CartIcon handle rendering via sessionStorage
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() }));
    } catch (e) {}
    // Direct update for immediate visual feedback
    var bubbles = document.querySelectorAll('.cart-bubble__text-count, [ref="cartBubbleCount"]');
    bubbles.forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
    var wrappers = document.querySelectorAll('.cart-bubble, [ref="cartBubble"]');
    wrappers.forEach(function (el) {
      el.classList.toggle('visually-hidden', count === 0);
    });
  }

  /* ---- Utility: format money (DKK, no decimals for whole amounts) ---- */
  function formatMoney(cents) {
    var amount = cents / 100;
    // Use Shopify's money format if available
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    // Fallback: Danish format
    var formatted = amount.toFixed(2).replace('.', ',');
    // Add thousands separator
    var parts = formatted.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',') + ' kr.';
  }

  /* ---- Utility: sized image URL ---- */
  function sizedImage(src, size) {
    if (!src) return '';
    return src.replace(/(\.[^.]+)$/, '_' + size + '$1');
  }

  /* ---- Utility: escape HTML ---- */
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }
})();
